import ApplicationController from "application_controller.js";
import Headroom from "headroom.js";

export default class extends ApplicationController  {
  debug = false;

  static values = {
    offset: { type: Number, default: 0 },
    toleranceUp: { type: Number, default: 0 },
    toleranceDown: { type: Number, default: 0 },
  };

  connect() {
    this.log_function("connect");

    this.headroomInstance = new Headroom(this.element, {
      offset: this.offsetValue || this.element.offsetHeight * 2,
      tolerance: {
        up: this.toleranceUpValue,
        down: this.toleranceDownValue,
      },
      //* When the header leaves the top it jumps from static to fixed;
      //* suppress the transition for that frame so it goes fixed already
      //* hidden instead of sliding out across the viewport
      onNotTop: () => this.suppressTransition(),
    });

    this.headroomInstance.init();

    //* Expose the header height so sticky elements can offset themselves
    //* below the pinned header (e.g. the deals table header)
    this.setHeaderHeightProperty();
    this.resizeHandler = this.setHeaderHeightProperty.bind(this);
    window.addEventListener("resize", this.resizeHandler);

    //* Turbo snapshots the body before disconnect runs, so strip headroom's
    //* classes beforehand or cached previews render the header out of flow
    this.beforeCacheHandler = this.destroyHeadroom.bind(this);
    document.addEventListener("turbo:before-cache", this.beforeCacheHandler);
  }

  disconnect() {
    this.log_function("disconnect");

    document.removeEventListener("turbo:before-cache", this.beforeCacheHandler);
    window.removeEventListener("resize", this.resizeHandler);
    this.destroyHeadroom();
  }

  destroyHeadroom() {
    this.headroomInstance?.destroy();
    this.headroomInstance = null;
  }

  suppressTransition() {
    this.element.classList.add("headroom--instant");
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.element.classList.remove("headroom--instant"));
    });
  }

  setHeaderHeightProperty() {
    document.documentElement.style.setProperty("--gt-header-height", `${this.element.offsetHeight}px`);
  }
}
